module.exports = __webpack_public_path__ + "img/magento-custom-development.7e1cef9c.webp";